/**
 * How far back the Activity feed reaches (YAR-168 AC16, decided Jul 28 and
 * matched to the Schedule tab's History page). A display boundary, not a
 * purge: older rows stay in the table — the deleted-item entry (YAR-172/173
 * AC6) is meant to be a lasting record — they are just not shown or counted.
 * The feed's end-of-list caption promises exactly this window (YAR-387).
 */
export const ACTIVITY_WINDOW_DAYS = 30;
